/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import Layout from "@/layout";

const depositRouter = {
  path: "/depositSetting",
  component: Layout,
  alwaysShow: true, // will always show the root menu
  name: "depositSetting",
  meta: {
    title: "입금 관리",
    icon: "won",
  },
  children: [
    {
      path: "allDepositSetting",
      component: () => import("@/views/deposit/DepositMainManage.vue"),
      name: "allDepositSetting",
      meta: {
        title: "종합입금 관리",
      },
    },
    {
      path: "refundSetting",
      component: () => import("@/views/deposit/RefundMainManage.vue"),
      name: "refundSetting",
      meta: {
        title: "환불/보류 관리",
      },
    },
    // {
    //   path: "landPaymentCalculate",
    //   component: () => import("@/views/deposit/BillSettingMainManage.vue"),
    //   name: "landPaymentCalculate",
    //   meta: {
    //     title: "지로납부정산 등록",
    //   },
    // },
    {
      path: "depositManual",
      component: () => import("@/views/deposit/DepositManualMainManage.vue"),
      name: "depositManual",
      meta: {
        title: "입금수동 등록",
      },
    },
    {
      path: "allDepositSettingDetail",
      component: () =>
        import("@/views/deposit/detail/DepositDetailSettingManage.vue"),
      name: "allDepositSettingDetail",
    },
  ],
};
export default depositRouter;
